import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTableFilter } from '@/shared';
import { useFetchTypeCompras, useUpdateTypeCompras } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { TIPOCOMPRAS } from '@/shared/interfaces';

const returnUrlTipoCompras = '/compras/tipo-compras';

export interface TiposComprasPageInterface {}

const TiposComprasPage: React.FC<TiposComprasPageInterface> = () => {
    const navigate = useNavigate();
///* table
const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;
///* fetch data
const {
    data: typeComprasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchTypeCompras({
    page: pageIndex + 1,
    nombre: searchTerm,
  });
  ///* mutations

  const updateIvaMutation = useUpdateTypeCompras({navigate, returnUrl:returnUrlTipoCompras});
///* handlers
const onEdit = (original: TIPOCOMPRAS) => {
    navigate(`${returnUrlTipoCompras}/editar/${original.id_tipo_compra}`);
  };
  ///* columns
  const columns = useMemo<MRT_ColumnDef<TIPOCOMPRAS>[]>(
    () => [
      {
        accessorKey: 'id_tipo_compra',
        header: 'ID',
        size: 90,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={iva => {
              updateIvaMutation.mutate({
                id: row.original.id_tipo_compra!,
                data: {
                  ...row.original,
                  estado: iva as boolean,
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Tipo de compras" urlRedirect={`${returnUrlTipoCompras}/crear`}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="tipo de compras" />

      <GeneralTable<TIPOCOMPRAS>
        columns={columns}
        data={typeComprasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={typeComprasPagingRes?.data?.count}
        // // actions
        
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default TiposComprasPage;